import moment from 'moment'
import { isValidNumber } from "data/lib/numbers"

const inputFormats = [
  'M/YY',
  'MM/YY',
  'M/YYYY',
  'MM/YYYY',
  'M/D/YY',
  'M/D/YYYY',
  'MM/DD/YY',
  'MM/DD/YYYY',
  'YYYY-MM-DD'
]
const outputFormat = 'YYYY-MM-DD'

export const checkDateMode = (datestring) => {
  let dateMode:string|null = null;
  if (isValidDate(datestring)) dateMode = "absolute"
  if (isValidNumber(datestring)) dateMode = "relative"
  return dateMode
}
export const checkDateSet = (datestring, items) => {
  let dateMode = checkDateMode(datestring);
  let homogenous:boolean = true;
  for (let i of items){
    if (isValidDate(i['date']) && dateMode !== "absolute"){
      homogenous = false
      break
    } else if (isValidNumber(i['date']) && dateMode !== "relative"){
      homogenous = false
      break
    }
  }
  return {dateMode, homogenous}
}

export const formatDate = (datestring, format=outputFormat, firstOfMonth=false) => {
  let date = parseDate(datestring)
  if (firstOfMonth) date = date.date(1)
  return date.format(format)
}

export const isValidDate = (datestring, formats=inputFormats) => moment(datestring, formats, true).isValid()

export const parseDate = (datestring, formats=inputFormats) => {
  let date = moment(datestring, formats)
  if (date.year() < 1000) {
    date.year(date.year() + 2000)
  }
  return date
}